import { type FC } from 'react'

import { DialogTitle } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

type CartIntermediateTitleType = {
  handleClose: () => void
}
export const CartIntermediateTitle: FC<CartIntermediateTitleType> = ({
  handleClose,
}) => {
  const { drawerMessages } = useCartIntermediateContext()
  const titleMessage = drawerMessages?.titleMessage

  return titleMessage ? (
    <DialogTitle className="bg-light-primary-medium" onClose={handleClose}>
      {titleMessage.message}
    </DialogTitle>
  ) : null
}
